import { render, staticRenderFns } from "./CrudPassengerModal.vue?vue&type=template&id=2774f256&"
import script from "./CrudPassengerModal.vue?vue&type=script&lang=js&"
export * from "./CrudPassengerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2774f256')) {
      api.createRecord('2774f256', component.options)
    } else {
      api.reload('2774f256', component.options)
    }
    module.hot.accept("./CrudPassengerModal.vue?vue&type=template&id=2774f256&", function () {
      api.rerender('2774f256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/transports/Modals/CrudPassengerModal.vue"
export default component.exports